import Datetime from "react-datetime";
import moment from "moment";
import React from "react";
import memoize from "memoize-one";

export const formatDate = memoize(value => {
    return value ? moment(value).locale("moment/locale/es").format("DD/MMM/YYYY") : "";
});

export const formatDateTime = memoize(value => {
    return value ? moment(value).locale("moment/locale/es").format("DD/MM/YYYY HH:mm:ss") : "";
});

export const BlkCalendario = ({ field, form, ...props }) => (
    <Datetime
        className={props.className}
        dateFormat={"DD/MM/YYYY"}
        timeFormat={false}
        value={field.value ? moment(field.value).format("DD/MM/YYYY") : ""}
        onChange={e => {
            if (e instanceof Object) {
                let date = moment(
                    e.format("DD/MM/YYYY") + " " + moment().format("HH:mm:ss"),
                    "DD/MM/YYYY HH:mm:ss"
                ).toDate();
                form.setFieldValue(field.name, date);
                if (props.onFieldSet) {
                    props.onFieldSet(date);
                }
            } else {
                if (e.length === 0) {
                    form.setFieldValue(field.name, "");
                    if (props.onFieldSet) {
                        props.onFieldSet("");
                    }
                }
            }
        }}
        onClose={() => {
            form.setFieldTouched(field.name, true);
        }}
        closeOnSelect={true}
        inputProps={{
            disabled: !!props.readOnly,
            placeholder: "DD/MM/AAAA",
        }}
    />
);

export const JedaiCalendarioViewText = ({ value }) => {
    let date = formatDate(value);
    return <span className="text-uppercase text">{date}</span>;
};

export const JedaiDateTimeViewText = ({ value }) => {
    let date = formatDateTime(value);
    return <span className="text-uppercase text">{date}</span>;
};
